import _ from 'lodash';

export default {
  QUESTION_REESPONSE_DEL: '~',
  addAllLocation(list, obj) {
    const newObj = obj || { id: '', name: 'All available locations', abbr: 'All available locations' };
    list.splice(0, 0, newObj);
    return list;
  },
  getLocationName(locationId, locations) {
    let locationName = '';
    if (typeof locationId === 'undefined' || locationId === null || locationId.trim() === '') {
      locationName = 'All available locations';
    } else {
      locationName = _(locations).find({ id: locationId }).name;
      if (!locationName) {
        locationName = 'All available locations';
      }
    }
    return locationName;
  },
  getLocationAbbr(locationId, locations) {
    let locationAbbr = '';
    if (typeof locationId === 'undefined' || locationId === null || locationId.trim() === '') {
      locationAbbr = 'All';
    } else {
      locationAbbr = _(locations).find({ id: locationId }).abbr;
      if (!locationAbbr) {
        locationAbbr = 'All';
      }
    }
    return locationAbbr;
  },
  getResponseId(indicatorId) {
    if (indicatorId && indicatorId.indexOf(this.QUESTION_REESPONSE_DEL) > -1) {
      return indicatorId.split(this.QUESTION_REESPONSE_DEL)[1];
    }
    return '';
  },
};



// WEBPACK FOOTER //
// ./src/components/LP/Maps/helper.js